export default {
  ADD_TALENT: (state, payload) => state.talent = Object.assign({}, { ...payload }),
}